<div class="text-center items-center flex flex-col gap-4">
  <vl-icon *ngIf="type == POPUP_ALERT_TYPE.DANGER" size="7xl" icon="times" pack="font-awesome-solid" status="primary"></vl-icon>
  <vl-icon *ngIf="type == POPUP_ALERT_TYPE.SUCCESS" size="7xl" icon="check-circle" pack="font-awesome-solid" status="success"></vl-icon>
  <vl-icon *ngIf="type == POPUP_ALERT_TYPE.INFO" size="7xl" icon="exclamation" pack="font-awesome-solid" status="info"></vl-icon>
  <vl-icon *ngIf="type == POPUP_ALERT_TYPE.WARNING" size="7xl" icon="exclamation-triangle" pack="font-awesome-solid" status="warning"></vl-icon>

  <div *ngIf="message" class="text-base font-mediumumum">
    {{ message }}
  </div>

  <ng-container *ngIf="template">
    <ng-container *ngTemplateOutlet="template"></ng-container>
  </ng-container>
</div>